export default function Hero() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative pt-20 md:pt-24 pb-12 md:pb-16 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>

      <div className="section-container relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 bg-primary-100/70 text-primary-700 text-xs md:text-sm font-medium px-4 py-1.5 rounded-full mb-4 md:mb-6">
              <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
              24小时不间断 · 每日更新
            </div>

            <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl font-black text-foreground-950 leading-tight text-balance">
              51吃瓜每日大赛
              <br />
              <span className="text-primary-500">全网热点吃瓜第一站</span>
            </h1>

            <p className="text-base md:text-lg text-foreground-600 mt-4 md:mt-6 max-w-xl mx-auto lg:mx-0 font-bold">
              今日热搜，一网打尽
            </p>

            <div className="mt-4 md:mt-6 text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 space-y-3">
              <p>
                51吃瓜每日大赛是全网领先的热点话题聚合平台，专注于7×24小时不间断追踪娱乐圈、社会热点、网红动态、影视综艺等各领域最新资讯。我们以最快的速度、最全的视角，为你呈现每日最值得关注的热门事件。
              </p>
              <p>
                无论是明星八卦、综艺翻车、直播事故还是品牌风波，只要是引发全网热议的"大瓜"，你都能在这里找到最完整的来龙去脉和最热辣的吃瓜视角。做全网最快乐的吃瓜人，从51吃瓜开始。
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mt-6 md:mt-8">
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-primary-500">200+</div>
                <div className="text-xs text-foreground-500 mt-0.5">日均更新条数</div>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-accent-500">50+</div>
                <div className="text-xs text-foreground-500 mt-0.5">覆盖内容平台</div>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-secondary-600">7×24h</div>
                <div className="text-xs text-foreground-500 mt-0.5">全天候实时追踪</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-6 md:mt-8">
              <a
                href="#cards"
                onClick={(e) => handleScroll(e, '#cards')}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-white font-semibold text-sm md:text-base px-6 py-3 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-eye-line"></i>
                开始吃瓜
              </a>
              <a
                href="#ranking"
                onClick={(e) => handleScroll(e, '#ranking')}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-background-100 hover:bg-background-200 text-foreground-800 font-semibold text-sm md:text-base px-6 py-3 rounded-lg transition-colors whitespace-nowrap cursor-pointer border border-background-300"
              >
                <i className="ri-fire-line text-accent-500"></i>
                今日热榜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3] lg:aspect-[5/4]">
              <img
                src="https://readdy.ai/api/search-image?query=A%20dramatic%20abstract%20composition%20with%20warm%20coral%20and%20deep%20amber%20tones%2C%20layered%20organic%20shapes%20resembling%20sound%20waves%20and%20social%20media%20networks%2C%20dynamic%20energy%20flow%2C%20modern%20digital%20art%20style%2C%20trending%20news%20visualization%2C%20bold%20contrast%2C%20editorial%20aesthetic%2C%20no%20text&width=1200&height=900&seq=hero-main&orientation=landscape"
                alt="51吃瓜每日大赛 - 全网热点聚合平台主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
            </div>

            <div className="grid grid-cols-3 gap-3 mt-3">
              <div className="rounded-xl overflow-hidden aspect-[4/3]">
                <img
                  src="https://readdy.ai/api/search-image?query=Abstract%20social%20media%20trending%20visualization%20with%20warm%20orange%20gradient%2C%20data%20flow%20patterns%2C%20modern%20minimal%20design%2C%20digital%20news%20aesthetic&width=400&height=300&seq=hero-sub-01&orientation=landscape"
                  alt="热搜趋势"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="rounded-xl overflow-hidden aspect-[4/3]">
                <img
                  src="https://readdy.ai/api/search-image?query=Abstract%20crowd%20discussion%20concept%20with%20warm%20coral%20tones%2C%20overlapping%20circles%20representing%20social%20bubbles%2C%20modern%20clean%20design&width=400&height=300&seq=hero-sub-02&orientation=landscape"
                  alt="全民热议"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="rounded-xl overflow-hidden aspect-[4/3]">
                <img
                  src="https://readdy.ai/api/search-image?query=Abstract%20real-time%20news%20update%20concept%20with%20golden%20amber%20accents%2C%20dynamic%20wave%20patterns%2C%20live%20feed%20aesthetic%2C%20modern%20design&width=400&height=300&seq=hero-sub-03&orientation=landscape"
                  alt="实时更新"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}